const layoutTypes = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
  TWOCOLUMN: "twocolumn",
  SEMIBOX: "semibox",
};

const layoutModeTypes = {
  LIGHTMODE: "light",
  DARKMODE: "dark",
};

const leftSidebarTypes = {
  LIGHT: "light",
  DARK: "dark",
  GRADIENT: "gradient",
  GRADIENT_2: "gradient-2",
  GRADIENT_3: "gradient-3",
  GRADIENT_4: "gradient-4",
};

const layoutWidthTypes = {
  FLUID: "lg",
  BOXED: "boxed",
};

const layoutPositionTypes = {
  FIXED: "fixed",
  SCROLLABLE: "scrollable",
};

const topbarThemeTypes = {
  LIGHT: "light",
  DARK: "dark",
};

const leftsidbarSizeTypes = {
  DEFAULT: "lg",
  COMPACT: "md",
  SMALLICON: "sm",
  SMALLHOVER: "sm-hover",
};

const leftSidebarViewTypes = {
  DEFAULT: "default",
  DETACHED: "detached",
};

const leftSidebarImageTypes = {
  NONE: "none",
  IMG1: "img-1",
  IMG2: "img-2",
  IMG3: "img-3",
  IMG4: "img-4",
};

const preloaderTypes = {
  ENABLE: "enable",
  DISABLE: "disable",
};

const sidebarVisibilitytypes = {
  SHOW: "show",
  HIDDEN: "hidden",
};

const productsStatus = {
  STATUS_IMPORTED: 5,
  STATUS_READYFORSTOCK: 4,
  STATUS_READYFORFINAL: 3,
  STATUS_READYFORPUBLISH: 2,
  STATUS_INACTIVE: 1,
  STATUS_PUBLISHED: 0,
  STATUS_REJECTED_INITIAL: 6,
  STATUS_REJECTED_STOCK: 7,
  STATUS_REJECTED_FINAL: 8,
};

const orderStatus = {
  STATUS_ACTIVE: 0,
  STATUS_ORDERED: 4,
  STATUS_CANCELLED: 5,
  STATUS_EXPIRED: 6,
  STATUS_SHIPPED: 7,
  STATUS_MOQNOTMET: 11,
  STATUS_MOVNOTMET: 12,
  STATUS_MOQ_MET: 20,
  STATUS_MOV_MET: 21,
};

const userType = {
  BC: 0,
  INITIALANALYSIS: 1,
  STOCKCHECK: 2,
  FINALANALYSIS: 3,
  ADMIN: 4,
};

export {
  layoutTypes,
  layoutModeTypes,
  leftSidebarTypes,
  layoutWidthTypes,
  layoutPositionTypes,
  topbarThemeTypes,
  leftsidbarSizeTypes,
  leftSidebarViewTypes,
  leftSidebarImageTypes,
  preloaderTypes,
  sidebarVisibilitytypes,
  productsStatus,
  userType,
  orderStatus,
};
